import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { I18nProvider } from './i18n';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Fleet from './pages/Fleet';
import Services from './pages/Services';
import Cities from './pages/Cities';
import Disneyland from './pages/Disneyland';
import Excursions from './pages/Excursions';
import Business from './pages/Business';
import About from './pages/About';
import Contact from './pages/Contact';
import Legal from './pages/Legal';
import Cgv from './pages/Cgv';
import Privacy from './pages/Privacy';
import { Toaster } from './components/ui/toaster';
import WhatsAppButton from './components/WhatsAppButton';

function App() {
  return (
    <I18nProvider>
      <BrowserRouter>
        <div className="min-h-screen flex flex-col bg-white text-black">
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/fleet" element={<Fleet />} />
              <Route path="/cities" element={<Cities />} />
              <Route path="/disneyland" element={<Disneyland />} />
              <Route path="/excursions" element={<Excursions />} />
              <Route path="/business" element={<Business />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/mentions-legales" element={<Legal />} />
              <Route path="/cgv" element={<Cgv />} />
              <Route path="/confidentialite" element={<Privacy />} />
            </Routes>
          </main>
          <Footer />
          <WhatsAppButton />
          <Toaster />
        </div>
      </BrowserRouter>
    </I18nProvider>
  );
}

export default App;
